import { ethers } from "ethers";

const RITUAL_CHAIN_ID_HEX = "0x7BB"; // 1979

// Địa chỉ contract từ log Hardhat
export const CONTRACT_ADDRESS =
  "0xbd29386F87D2527416639db095F89051CdCD4879";

export const CONTRACT_ABI = [
  "function PLAY_FEE() view returns (uint256)",
  "function play() payable",
  "function playCount(address) view returns (uint256)",
  "event Played(address indexed user, uint256 amount)",
];

export async function ensureRitualNetwork() {
  const { ethereum } = window as any;
  if (!ethereum) throw new Error("MetaMask not found");

  const chainId = await ethereum.request({ method: "eth_chainId" });
  if (chainId === RITUAL_CHAIN_ID_HEX) return;

  try {
    await ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: RITUAL_CHAIN_ID_HEX }],
    });
    return;
  } catch (switchError: any) {
    if (switchError?.code !== 4902) {
      // If the chain is already added but the wallet is on another network,
      // MetaMask should switch. Otherwise, propagate the error.
      throw switchError;
    }
  }

  try {
    await ethereum.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: RITUAL_CHAIN_ID_HEX,
          chainName: "Ritual",
          nativeCurrency: { name: "Ritual", symbol: "RITUAL", decimals: 18 },
          rpcUrls: ["https://rpc.ritualfoundation.org"],
          blockExplorerUrls: ["https://explorer.ritualfoundation.org"],
        },
      ],
    });
  } catch (addError: any) {
    // If the chain already exists with a different configuration, just switch to it.
    if (addError?.code === -32603 || addError?.message?.includes("nativeCurrency.symbol") || addError?.message?.includes("does not match")) {
      await ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: RITUAL_CHAIN_ID_HEX }],
      });
      return;
    }
    throw addError;
  }
}

export async function connectWallet(): Promise<string> {
  const { ethereum } = window as any;
  if (!ethereum) throw new Error("MetaMask not found");
  await ensureRitualNetwork();
  const accounts = await ethereum.request({ method: "eth_requestAccounts" });
  return accounts[0];
}

export async function playGame() {
  const { ethereum } = window as any;
  if (!ethereum) throw new Error("MetaMask not found");
  await ensureRitualNetwork();

  const provider = new ethers.BrowserProvider(ethereum);
  const signer = await provider.getSigner();
  const contract = new ethers.Contract(CONTRACT_ADDRESS, CONTRACT_ABI, signer);

  const fee: bigint = await contract.PLAY_FEE();
  console.log("PLAY_FEE =", fee.toString());

  const tx = await contract.play({ value: fee });
  console.log("tx hash:", tx.hash);

  const receipt = await tx.wait();
  console.log("receipt in playGame:", receipt);

  return receipt;
}